import _ from "lodash";

export {
    prepareParentFacebookSearchInterestList,
    prepareDesignSearchInterestList,
}

const prepareParentFacebookSearchInterestList = (parentProduct, allTags) => {
    let searchInterestTextList = [];
    searchInterestTextList.push(parentProduct?.productType);
    searchInterestTextList.push(parentProduct?.title);
    searchInterestTextList.push(parentProduct?.name);
    searchInterestTextList.push(parentProduct?.model);
    searchInterestTextList.push(parentProduct?.category);

    let parentCategories = _.split(parentProduct?.parentCategory, '|');
    parentCategories = _.map(parentCategories, (category) => {
        return _.trim(category);
    });
    searchInterestTextList = _.concat(searchInterestTextList, parentCategories);

    const tagsMap = _.keyBy(allTags, 'id');
    _.forEach(parentProduct?.tagList, (tagId) => {
        searchInterestTextList.push(tagsMap[tagId]?.startText);
    });

    searchInterestTextList = _.uniq(_.compact(searchInterestTextList));
    return searchInterestTextList;
}

const prepareDesignSearchInterestList = (designDetail, parentProductSearchIneterestList) => {
    let searchInterestTextList = designDetail?.designTags;

    searchInterestTextList = _.filter(searchInterestTextList, (searchInterestText) => {
        return !_.includes(parentProductSearchIneterestList, searchInterestText);
    });

    searchInterestTextList = _.uniq(_.compact(searchInterestTextList));
    return searchInterestTextList;
}
